export const enable_state = (state) => ({
  type: 'enable_state',
  payload: state,
});

export const disable_state = (state) => ({
  type: 'disable_state',
  payload: state,
});
